import { render, staticRenderFns } from "./ttshop_orderxq.vue?vue&type=template&id=60c7b84c&scoped=true&"
import script from "./ttshop_orderxq.vue?vue&type=script&lang=js&"
export * from "./ttshop_orderxq.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_orderxq.vue?vue&type=style&index=0&id=60c7b84c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c7b84c",
  null
  
)

export default component.exports